import UniqueIdGenerator from './uniqueId/uniqueId';
import NanoIdGenerator from './nanoid/nanoIdGenerator';

const uniqueId = new UniqueIdGenerator(new NanoIdGenerator());

export default uniqueId;
